import {ProjectRouteStation} from "./project-route-station.interface";
import { SchemaRouteStationInfo } from "../../project-schema/shared/interfaces/schema-route-station-info.interface";
import { Recordings } from "./recordings.interface";

export class ProjectRouteStationWithParam {
  public routeStation: ProjectRouteStation;
  /** Vorbereitete Anzeige-Sicht (SchemaRouteStationInfo) — einzige Geraetedaten-Quelle der Views */
  public schemaInfo?: SchemaRouteStationInfo;
  public recordings: Recordings[];
  public selectedRecording?: Recordings;

  constructor(routeStation: ProjectRouteStation, schemaInfo?: SchemaRouteStationInfo) {
    this.routeStation = routeStation;
    this.schemaInfo = schemaInfo;
    this.recordings = [];
    this.selectedRecording = undefined;
  }
}
